<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="evidences"
      class="elevation-1"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:item.justificativa="{ item }">
        <v-text-field
          label="Justificativa"
          name="justificativa"
          type="text"
          required
          v-model="item.justificativa"
        ></v-text-field>
      </template>

      <template v-slot:item.nomeArquivo="{ item }">
        <span :title="getEvidenciaTitle(item)">{{ item.nomeArquivo }}</span>
        <v-btn
          v-if="canDeleteRejectedEvidence(item)"
          icon
          small
          color="error"
          class="ml-2"
          title="Excluir esta evidência"
          aria-label="Excluir esta evidência"
          @click.stop="deleteRejectedEvidence(item)"
        >
          <v-icon small>mdi-trash-can-outline</v-icon>
        </v-btn>
      </template>

      <template v-slot:item.acoes="{ item }">
        <v-btn
          v-if="
            isFullAdmin ||
            (canAnalyze &&
              (filtro === 'evidenciada' || filtro === 'rejeitada') &&
              item.aprovada !== true &&
              groupsConfig[`analisar${type}`] &&
              config[`analisar${type}`])
          "
          outlined
          color="primary"
          class="ml-3 buttonCustom"
          @click="evaluateIssue(item, true)"
        >
          <span>Aprovar</span>
        </v-btn>

        <v-btn
          v-if="
            isFullAdmin ||
            (canAnalyze &&
              (filtro === 'evidenciada' || filtro === 'aprovada') &&
              item.rejeitada !== true &&
              groupsConfig[`analisar${type}`] &&
              config[`analisar${type}`])
          "
          outlined
          color="error"
          class="ml-3 buttonCustom"
          @click="evaluateIssue(item, false)"
        >
          <span>Rejeitar</span>
        </v-btn>

        <v-btn
          v-if="
            isFullAdmin ||
            (canAnalyze &&
              groupsConfig[`analisar${type}`] &&
              config[`analisar${type}`])
          "
          outlined
          color="primary"
          class="ml-3 buttonCustom"
          @click="evaluateIssue(item, false)"
        >
          <span>Atualizar</span>
        </v-btn>

        <v-btn
          outlined
          color="primary"
          class="ml-3 buttonCustom"
          @click="downloadEvidence(item)"
        >
          <span>Ver Evidência</span>
        </v-btn>
      </template>

      <template v-slot:item.status="{ item }">
        <td v-if="item.aprovada === true">
          <div class="hasEvidence"></div>
        </td>
        <td v-else-if="item.rejeitada === true">
          <div class="hasNoEvidence"></div>
        </td>
        <td v-else>
          <div class="semStatus"></div>
        </td>
      </template>

      <template slot="no-data">
        <span> Nenhuma evidência retornada </span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { cityQuestionAPI } from "@/modules/city";
import { evidenceQuestionAPI } from "@/modules/evidence";
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";
export default {
  name: "AppGetEvidenceQuestion",
  props: {
    perguntaId: { type: Number, required: true, default: null },
    evidences: { type: Array, default: () => [] },
    type: { type: String, required: true, default: "" },
    canAnalyze: { type: Boolean, default: true },
  },
  data() {
    return {
      headers: [
        { text: "Nome do Arquivo de Evidência", value: "nomeArquivo" },
        { text: "Justificativa", value: "justificativa" },
        { text: "Ações", value: "acoes" },
        { text: "Status", value: "status" },
      ],
      payload: {
        municipioId: this.$route.params.id,
      },
      evidencias: [],
      filtro: "evidenciada",
      activeBtn: 0,
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    canDeleteRejectedEvidence(item) {
      return (
        this.type === "Rejeitadas" &&
        this.isAdmin &&
        !this.isSala &&
        this.canAnalyze &&
        item.aprovada !== true &&
        this.config &&
        this.config.descartarEvidencias &&
        this.groupsConfig &&
        this.groupsConfig.descartarEvidencias
      );
    },
    deleteRejectedEvidence(item) {
      if (!this.canDeleteRejectedEvidence(item)) return;

      Swal.fire({
        title: "Excluir evidência",
        text: `Deseja excluir apenas a evidência ${item.nomeArquivo}? A pergunta continuará na aba Rejeitadas.`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
      }).then((result) => {
        if (!result.isConfirmed) return;

        this.setLoading(true);
        evidenceQuestionAPI
          .deleteEvidence(item.perguntaEvidenciaId)
          .then(() => {
            this.$emit("evidenceDeleted", item.perguntaEvidenciaId);
            this.$notification.success("Evidência excluída com sucesso");
          })
          .catch(() => {
            this.$notification.error("Erro ao excluir evidência");
          })
          .finally(() => this.setLoading(false));
      });
    },
    loadQuestion() {
      this.setLoading(true);
      cityQuestionAPI
        .getPergunta(this.perguntaId)
        .then((resp) => {
          this.evidencias = resp.data.evidencias;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter pergunta");
        });
    },
    evaluateIssue(evidencia, situacao) {
      if (situacao === true) {
        evidencia.aprovada = true;
        evidencia.rejeitada = false;
      } else {
        if (!evidencia.justificativa) {
          this.$notification.error(
            "É obrigatório o preenchimento de uma justificativa para evidencias rejeitadas!"
          );
          return;
        }
        evidencia.rejeitada = true;
        evidencia.aprovada = false;
      }

      let formData = new FormData();

      formData.append("aprovada", evidencia.aprovada);
      formData.append("nomeArquivo", evidencia.nomeArquivo);
      formData.append("perguntaEvidenciaId", evidencia.perguntaEvidenciaId);
      formData.append("perguntaMunicipioId", evidencia.perguntaMunicipioId);
      formData.append("rejeitada", evidencia.rejeitada);
      formData.append("usuarioId", evidencia.usuarioId);
      formData.append("Justificativa", evidencia.justificativa || "");
      this.setLoading(true);
      evidenceQuestionAPI
        .update(formData)
        .then((resp) => {
          this.setLoading(false);
          this.$notification.success("Evidência avaliada com sucesso!", {
            success: {
              background: "#483D8B",
              color: "#fff",
            },
          });
          this.loadQuestion();
          this.$emit("updateValue", evidencia);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao avaliar evidência");
        });
    },
    update(evidencia) {
      this.setLoading(true);
      evidenceQuestionAPI
        .update(evidencia)
        .then((resp) => {
          this.setLoading(false);
          this.$notification.success("Evidência atualizada com sucesso!");
          this.loadQuestion();
          this.$emit("updateValue", evidencia);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao atualizar evidência");
        });
    },
    downloadEvidence(evidence) {
      this.setLoading(true);
      evidenceQuestionAPI
        .download(evidence.perguntaEvidenciaId)
        .then(async (resp) => {
          const contentType = resp.headers["content-type"] || "";
          if (contentType.includes("application/json")) {
            const payload = JSON.parse(await resp.data.text());
            if (payload.url) {
              let link = document.createElement("a");
              link.href = payload.url;
              link.target = "_blank";
              link.click();
              this.setLoading(false);
              return;
            }
          }

          let blob = new Blob([resp.data], {
            type: contentType,
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.target = "_blank";
          link.click();

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter evidencia");
        });
    },
    formatDate(value) {
      if (!value) return "";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return "";
      return date.toLocaleDateString("pt-BR");
    },
    getEvidenciaTitle(item) {
      if (!this.exibirRastreamento) return null;

      const linhas = [];
      const inseridoPor =
        item.usuarioInsercaoNome || item.usuarioInsercao || item.usuarioId;
      const dataInsercao = this.formatDate(item.dataInsercao);

      if (inseridoPor) {
        linhas.push(
          `Inserido por ${inseridoPor}${
            dataInsercao ? `, em ${dataInsercao}` : ""
          }`
        );
      }

      if (
        (item.aprovada || item.rejeitada) &&
        (item.usuarioAnaliseNome || item.usuarioAnalise || item.dataAnalise)
      ) {
        const analisadoPor =
          item.usuarioAnaliseNome || item.usuarioAnalise || "";
        const dataAnalise = this.formatDate(item.dataAnalise);
        linhas.push(
          `Analisado por: ${analisadoPor}${
            dataAnalise ? ` em ${dataAnalise}` : ""
          }`
        );
      }

      return linhas.length ? linhas.join("\n") : null;
    },
  },
  mounted() {},
  computed: {
    ...mapGetters([
      "isAdmin",
      "isFullAdmin",
      "isSala",
      "isParceiro",
      "isCE",
      "isDT",
      "isTerritorio",
    ]),
    exibirRastreamento() {
      return (
        !this.isSala &&
        !this.isParceiro &&
        (this.isCE || this.isDT || this.isTerritorio)
      );
    },
  },
};
</script>

<style>
.buttonCustom {
  font-size: 12px !important;
  padding: 0 10px !important;
}
</style>
